//import { initSwiper } from "./modules/functions.js";
//import { SWIPERS } from "./swiper/data.js";
//import { modalHide } from "./modules/modalHide.js";
//import { inputRule } from "./modules/inputRule.js";
//import { burgerMenu } from "./modules/burgerMenu.js";
//import { phoneMask } from "./modules/phoneMask.js";

const initSwipers = () => {
  initSwiper(SWIPERS.GALLERY.selector, { ...SWIPERS.GALLERY.options });
};

document.addEventListener("DOMContentLoaded", () => {
    initSwipers()
    modalHide()
    inputRule()
    burgerMenu()
    phoneMask()
});
